import { useEffect, useRef } from 'react';

let lockCount = 0;

function applyLock() {
  document.body.style.overflow = 'hidden';
  document.body.style.touchAction = 'none';
  document.documentElement.style.overflow = 'hidden';
  const mainEl = document.querySelector('main') as HTMLElement | null;
  if (mainEl) mainEl.style.overflow = 'hidden';
}

function releaseLock() {
  document.body.style.overflow = '';
  document.body.style.touchAction = '';
  document.documentElement.style.overflow = '';
  const mainEl = document.querySelector('main') as HTMLElement | null;
  if (mainEl) mainEl.style.overflow = 'auto';
}

export function useScrollLock(isActive: boolean) {
  const isLocked = useRef(false);

  useEffect(() => {
    if (isActive && !isLocked.current) {
      isLocked.current = true;
      lockCount++;
      if (lockCount === 1) applyLock();
    } else if (!isActive && isLocked.current) {
      isLocked.current = false;
      lockCount--;
      if (lockCount === 0) releaseLock();
    }

    return () => {
      if (isLocked.current) {
        isLocked.current = false;
        lockCount--;
        if (lockCount === 0) releaseLock();
      }
    };
  }, [isActive]);
}
